import { ExpiringSoonIcon } from './ExpiringSoonIcon';
import { RepeatsIcon } from './Repeats';
import styles from './StatusIcon.module.scss';

export function StatusIcons({
  expiringSoon,
  expiringDate,
  repeats,
}: {
  expiringDate?: null | any;
  expiringSoon?: null | boolean;
  repeats?: null | boolean;
}): JSX.Element {
  return (
    <div className={styles['status-icons']}>
      {expiringSoon && (
        <ExpiringSoonIcon key={'exp'} expiringDate={expiringDate} />
      )}
      {repeats && <RepeatsIcon key={'rpt'} />}
    </div>
  );
}
